import { Box, Grid2, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import { Rating } from 'react-simple-star-rating'
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Constant from '../../../../../Utils/Constant';
import moment from 'moment';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
import Skeleton from 'react-loading-skeleton';
const IntrepreterReview = (props) => {
    const { interpreterRateAndReview, isLoading } = props;
    return (
        <Fragment>
            <Box sx={{
                width: '100%',
                padding: '20px 10px 0px 10px',
                height: 'calc(100vh - 250px)',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
            }}>
                <Grid2 container spacing={2} height={
                    interpreterRateAndReview && interpreterRateAndReview?.length > 0 ? "auto" : "100%"
                }>
                    {isLoading ? (
                        <>
                            {[...Array(5)].map((_, index) => (
                                <Grid2 size={{ xs: 12, md: 6, lg: 6, xl: 4 }} key={index}>
                                    <Skeleton variant="circle" height={100} />
                                </Grid2>

                            ))}
                        </>
                    ) : interpreterRateAndReview?.length > 0 ? interpreterRateAndReview?.map((elem, index) => {
                        return (
                            <Grid2 key={index} size={{ xs: 12, md: 6, lg: 6, xl: 4 }}>
                                <Box key={index} sx={{
                                    width: '100%',
                                    background: "#FAFAFA",
                                    border: "1px solid #08557F33",
                                    padding: '15px',
                                    borderRadius: '15px',
                                    width: '100%',

                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: 1,
                                    }}>
                                        <Box sx={{
                                            display: 'flex',
                                            // alignItems: 'center',
                                            gap: 1,
                                        }}>
                                            {elem?.profile_img ? <img
                                                src={`${Constant.BASE_URL}${elem?.profile_img}`}
                                                alt="interpreter_Profile"
                                                style={{
                                                    width: "40px",
                                                    height: "40px",
                                                    objectFit: "cover",
                                                    borderRadius: "50%",
                                                    objectPosition: "top",
                                                }}
                                            /> : <AccountCircleIcon sx={{ fontSize: "40px" }} />}
                                            <Box sx={{}}>
                                                <Typography
                                                    sx={{
                                                        fontSize: "16px",
                                                        fontWeight: "300",
                                                        color: "rgba(40, 29, 27, 1)",
                                                        textAlign: "left",
                                                        width: "100%",
                                                        fontFamily: "Outfit",
                                                        fontWeight: '600'
                                                    }}
                                                >
                                                    {elem?.full_name || "-"}
                                                </Typography>
                                                <Rating
                                                    initialValue={elem?.rating}
                                                    size={20}
                                                    activeColor="blue"
                                                    inactiveColor="gray"
                                                />
                                                <Typography
                                                    sx={{
                                                        fontSize: "14px",
                                                        fontWeight: "300",
                                                        color: "rgba(0, 0, 0, 0.8)",
                                                        width: "100%",
                                                        fontFamily: "Outfit",
                                                        padding: '10px 0px'
                                                    }}
                                                >
                                                    {elem?.review || '-'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontSize: "14px",
                                                fontWeight: "300",
                                                color: "rgba(0, 0, 0, 0.6)",
                                                textAlign: "center",
                                                fontFamily: "Outfit"
                                            }}
                                        >
                                            {moment(elem?.created_at).fromNow() || "Just now"}
                                        </Typography>
                                    </Box>

                                </Box>
                            </Grid2>
                        )
                    })
                        : <Grid2 size={{ xs: 12 }}
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                            <NoDataImg />
                        </Grid2>}
                </Grid2>

            </Box>
        </Fragment>
    );
};

export default IntrepreterReview;